// extracted by mini-css-extract-plugin
export default {"fullWidth":"Dh-z","hasStyledAspectRatio":"Eh-z"};